export default "__VITE_ASSET__DSWPW0s8__"